module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAA2klEQVRIibXWMQ7CMAwF0ByEjV4MTsCNWNkYu7H2DjD2HPBRRZAqy3HsnyRShlppnqy4bhKA6DwCeAA4RN9loBW/8YyCDPQGcGNABjrn2CUKslBiwBYoDDKQVo0ukIFK1VgFWQgM2AKFwVYoBPaA3GAvyAVugSUHruL8FmNTa8xin3teO28P0y6z027RRGT2UjL7/ONy4xbQhGQ1toBVSPvOGNAFlTpIBNSqT4Ws3ugBQ5CFWWCp65tQDbPAJCDt7MKYBIf+qS1wyB1EA4ferjzV2B0rVWN9AukLrR5owWiOfU0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zdwed.png
// module id = /70e
// module chunks = 1